module.exports = {
  game: 'Game',
  gameNameTranslations: {
    'bingo90': 'Bingo 90',
    'bingolite': 'Bingo Lite',
    'bingo75': 'Bingo 75',
    'classic': 'Las Vegas',
    'egyptian': 'Egypte',
    'suits': 'Poker',
    'deep': 'Diepzee',
    'sacred': 'Heilige Steen',
    'goldrush': 'Goudkoorts',
    'bubble': 'Bubbel',
    'galleon': 'Galjoen',
    'phoenix': 'Feniks',
    'cosmos': 'Kosmos',
    'pop': 'Belletjes',
    'lab': 'Lab',
    'carnival': 'kermis',
    'invasion': 'UFO',
    'vikings': 'vikingen',
    'pirate': 'Piraten Vloek',
    'emoji': 'Emoji',
    'numbers': 'Nummers',
    'temple': 'tempel',
    'parade': 'parade',
    'wanted': 'Wild West',
    'wildwood': 'Skovens Magi'
  },
  prize: {
    currencySymbol: '€',
    currencySymbolForPennies: '€'
  },
  jackpot: {
    won: 'JACKPOT WON',
    notWon: 'No jackpot winners this game',
    title: 'Jackpot'
  },
  winners: {
    gameWinnersModalTitle: 'Winners',
    previousGameWinners: 'Past 10 Winners',
    previousJackpotWinners: 'Past 10 Jackpot Winners',
    previousBonusGameWinners: 'Past 10 Bonus Game Winners',
    previousHamsterRaceBigWinners: 'Past 10 Largest Winners',
    previous100GameWinners: 'Past 100 Winners',
    tableHeaders: {
      gameId: 'Game Id',
      stamp: 'Stamp',
      winners: 'Winners',
      room: 'Room'
    },
    winnerTemplate: '{username} - £{prize} ',
    winnersWindow: {
      tableHeaders: {
        game: 'Game',
        username: 'Name',
        prize: 'Prize'
      },
      freeze: 'freeze',
      title: 'Game Winners',
      copy: 'Copy'
    },
    popup: {
      title: 'Winner!',
      message: '{username} Gefeliciteerd! {prize} {gameName}',
      extendedMessage: '{username} Gefeliciteerd! {prize} {gameName} ({prizeType})'
    }
  },
  hamsterRace: {
    lastEigthWinnersTitle: 'Last 8 Winners',
    firstPlace: '1st',
    hamster: 'Hamster',
    wins: 'Wins',
    winners: {
      tableHeaders: {
        winningHamster: 'Winning Hamster'
      }
    }
  },
  rollercoaster: {
    lastSixCallsTitle: 'Last 6 Calls'
  },
  arcade: {
    winners: {
      tableHeaders: {
        winnerName: 'Winner Name',
        gameName: 'Game Name',
        prize: 'Prize',
        stamp: 'Stamp'
      }
    },
    gameNameFormat: '{gameName}'
  },
  quizQuids: {
    tableHeaders: {
      winnerName: 'Winner Name',
      chatModeratorName: 'Chatmod Name',
      stamp: 'Stamp'
    }
  },
  pictureBingo: {
    winners: {
      tableHeaders: {
        theme: 'Theme'
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/nl/game.js
// module id = pd1h
// module chunks = 1